import * as yup from "yup";

export const appSettingSchema = yup.object().shape({
  settingId: yup.string().label("Setting").nullable(),
  settingIds: yup.array().label("Setting Ids").nullable(),
  defaultValue: yup.string().label("Default Value").default("").nullable(),
  enabled: yup.boolean().label("Enabled").default(true),
});
